export const centeredPositionOffset = (width: number, height: number) => ({
  x: -(width / 2),
  y: -(height / 2),
});

export const bottomCenteredPositionOffset = (
  width: number,
  height: number,
) => ({
  x: -(width / 2),
  y: -height,
});
